/* eslint-disable react-refresh/only-export-components */
import { useState } from "react";
import { NavLink, withRouter } from "react-router-dom";

import Text from "@/newComponents/typography/Text";
import { useUIStateStore } from "@/store/uiStateStore";

import useGetColours from "../helpers/getColours";

function SideNavItem(props) {
  const {
    icon,
    to,
    title,
    exact,
    subtitle,
    disabled,
    id,
    match,
    location,
  } = props;
  const { highlightColour } = useGetColours();
  const [hovering, setHovering] = useState(false);
  const isActive = match.url === to || (exact && location.pathname === to);
  const inActiveColour = "#A09E9F";
  const activeStyle = {
    color: isActive ? highlightColour : inActiveColour,
  };
  const isTunecore = useUIStateStore(state => state.isTunecore);

  if (!disabled) {
    return (
      <NavLink
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        id={id}
        exact={exact}
        className={`rounded-lg xl:rounded-none m-2 xl:m-0 side-nav-item flex justify-center items-center gap-3.5 p-3 xl:pl-7 xl:pr-7 xl:py-12 z-10 relative ${
          isTunecore
            ? `hover:bg-tunecore-light-grey ${isActive ? "bg-tunecore-light-grey" : ""}`
            : `hover:bg-sentric-very-light-grey ${isActive ? "bg-sentric-very-light-grey" : ""}`
        }`}
        to={to}
        activeStyle={activeStyle} // Apply the activeStyle when NavLink is active
      >
        <div
          style={{
            color: hovering || isActive ? highlightColour : inActiveColour,
          }}
          className="block text-xl"
        >
          {icon}
        </div>
        <div className="text-black">
          <Text as="p" className={` text-base font-semibold  ${isTunecore ? "text-white" : "text-black"}`}>{title}</Text>
          <Text as="p" className={`hidden text-sm xs:block font-sentric-alt ${isTunecore ? "text-white" : "text-sentric-dark-background"}`}>{subtitle}</Text>
        </div>
      </NavLink>
    );
  }

  return (
    <div className={`rounded-lg xl:rounded-none m-2 xl:m-0 flex justify-start gap-3.5 p-3 xl:pl-7 xl:pr-7 xl:py-12 z-10 relative ${
      isTunecore ? "" : "rb-side-nav-item"
    }`}
    >
      <div className="text-2xl lg:text-3xl text-sentric-rebrand-sidenav-icon-grey">
        {icon}
      </div>
      <div>
        <Text as="p" className="mb-1 text-base font-semibold text-sentric-rebrand-low-opacity-grey">{title}</Text>
        <Text as="p" className="hidden xs:block font-sentric-alt text-sentric-rebrand-low-opacity-greyext-xs">{subtitle}</Text>
      </div>
    </div>
  );
}

export default withRouter(SideNavItem);
